import styled from "styled-components";

export const MasterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33px;
  margin-inline: 25px;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  color: white;
  font-size: 14px;
  max-width: 1400px;
`; 